import React from 'react';
import { Card, Button, ErrorAlert } from '../../../components/shared';

const MODES = [
  {
    key: 'EKYC',
    title: 'eKYC - Xác minh tự động',
    description: 'Chụp CMND/CCCD để tự động nhận dạng thông tin',
    recommended: true,
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" />
      </svg>
    ),
  },
  {
    key: 'MANUAL',
    title: 'Nhập thông tin thủ công',
    description: 'Tự nhập toàn bộ thông tin cá nhân',
    recommended: false,
    icon: (
      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
      </svg>
    ),
  },
];

export default function VdscRegisterModeSelect({ onSelect, onBack, loading, error }) {
  return (
    <div className="mx-auto max-w-lg">
      <Card>
        <div className="space-y-6">
          <div className="text-center">
            <h2 className="text-lg font-semibold text-gray-900">Chọn phương thức đăng ký</h2>
            <p className="mt-1 text-sm text-gray-500">Chọn cách thức xác minh thông tin để mở tài khoản</p>
          </div>

          <ErrorAlert error={error} />

          <div className="space-y-3">
            {MODES.map((mode) => (
              <button
                key={mode.key}
                onClick={() => onSelect(mode.key)}
                disabled={loading}
                className="flex w-full items-start gap-4 rounded-xl border border-gray-200 px-5 py-4 text-left transition-colors hover:border-blue-300 hover:bg-blue-50 disabled:opacity-50"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
                  {mode.icon}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium text-gray-900">{mode.title}</span>
                    {mode.recommended && (
                      <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">
                        Khuyến nghị
                      </span>
                    )}
                  </div>
                  <p className="mt-0.5 text-sm text-gray-500">{mode.description}</p>
                </div>
              </button>
            ))}
          </div>

          <button onClick={onBack} className="w-full text-center text-sm text-gray-500 hover:text-gray-700">
            Quay lại
          </button>
        </div>
      </Card>
    </div>
  );
}
